import rules from "abusesa-js/rules";

import createReducerMixin from "./createReducerMixin";
import TimeFilter from "../lib/TimeFilter";
import Mappable from "lib/Mappable";

const FILTER_PROPS = ["filter", "timespan"];

const getData = props => props.dataset || {name: null, data: []};

const gerateName = props => getData(props).name + " filtered by " + FILTER_PROPS.map(prop => props[prop]);

function filter(state, nextProps, oldProps) {
    let filter = nextProps["filter"] ? rules.parse(nextProps["filter"]) : null,
        timekeys = nextProps.dataset.keys["observation time"] ?
            ["observation time"] :
            Object.keys(nextProps.dataset.keys).filter(key => nextProps.dataset.keys[key].includes("time")),
        timespan = TimeFilter.parse(nextProps["timespan"], {timezone: nextProps["timezone"], timeKeys: timekeys});

    if (!filter && !timespan) {
        let empty = {};
        // we need to set every previous key explicitly to null,
        // otherwise setState will not update those values
        Object.keys(state).forEach(key => empty[key] = null);
        return empty;
    }

    let name = gerateName(nextProps);

    if (getData(oldProps) !== getData(nextProps) || name !== state.name) {
        let dataset = getData(nextProps);

        let oldData = [];
        let oldFilteredData = [];

        // allow an incremental update only when it can be safely done:
        // only if data has been appended while filters and selected dataset remain unchanged
        if (name === state.name) {
            oldData = getData(oldProps).data;
            oldFilteredData = state.data || [];
        }

        let newData = dataset.data.slice(oldData.length);

        newData = newData.filter(item => {
            let event = {event: item};

            if (filter && !filter(event)) {
                return false;
            }

            if (timespan && !timespan(event)) {
                return false;
            }

            return true;
        });

        state = {...dataset, name, data: oldFilteredData.concat(newData)};
    }

    return state;
}

export default function filterDataset(WrappedComponent) {
    return class DataFilter extends createReducerMixin(WrappedComponent, filter) {
        static displayName = 'DataFilter';

        render() {
            let {dataset} = this.props;

            if (this.state.name) {
                dataset = this.state;
            }

            let props = new Mappable(this.props)
                .filter((val, key)=> !FILTER_PROPS.includes(key))
                .toObject();

            return super.render({...props, dataset});
        }
    };
}



// WEBPACK FOOTER //
// ./src/kpi/common/DataFilter.js